export default {
  estados: [],
  estado: null,
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
